<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>通道闸管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <span style="margin-left:20px">设备名称：</span>
            <el-input placeholder="请输入设备名称" v-model="search.passGateName" clearable></el-input>
            <span style="margin-left:1vw;">设备号：</span>
            <el-input style="margin-right:20px" placeholder="请输入设备号" v-model="search.serialNo" clearable></el-input>
            <el-button style="margin-right:20px" type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
            <el-button type="success" @click="downCard">一键下发卡号</el-button>
            <el-button type="primary" @click="addRow" style="margin-left:2vw;">绑定通道闸设备</el-button>
          </div>
          
          <!-- 表格 -->
          <div class="build-table">
            <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;"  :header-cell-style="{background:'#F5F7F9',color:'#909399'}"> 
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
               <el-table-column label="设备名称">
                <template slot-scope="scope">
                  <a>{{ scope.row.passGateName}}</a>
                </template>
              </el-table-column>
              <el-table-column label="设备号">
                <template slot-scope="scope">
                  <a>{{ scope.row.serialNo}}</a>
                </template>
              </el-table-column>
              <el-table-column label="设备IP">
                <template slot-scope="scope">
                  <span>{{ scope.row.passGateIp }}</span>
                </template>
              </el-table-column>
              <el-table-column label="在线时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.updateDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  <!-- <el-button size="mini" type="success" @click="downCard(scope.row)">一键下发卡号</el-button> -->
                </template>
              </el-table-column>

              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
                width="30%"
              >
                <el-form
                  :model="addForm"
                  ref="addForm"
                  label-width="150px"
                  :label-position="labelPosition"
                >
                  <el-form-item label="设备名称：">
                    <el-input style="width:220px"  v-model="addForm.passGateName" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="设备号：">
                    <el-input style="width:220px" v-model="addForm.serialNo" placeholder="请输入Sn" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="设备IP：">
                    <el-input style="width:220px" v-model="addForm.passGateIp" placeholder="请输入4位字符串" autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
         

        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      search:{
        passGateName:'',
        serialNo:'',
        projectId:''
      },
      dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {
         passGateId:'', 
         passGateName:'',
         serialNo:'',
         projectId:'',
         passGateIp:''
      }, // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      projectName: '',
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      dtuImei:''
    }
  },
  mounted() {
    this.groupId = this.groupId&&this.groupId!=''?this.groupId:util.session.get('groupId')
    this.search.groupId = this.groupId
    this.getList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },

    //获取列表
    getList() {
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      this.search.projectId = this.groupId
      var that = this
      myHttp.findEquipPassGateList(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.total
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.addForm={
        passGateName:row.passGateName,
        passGateId:row.passGateId,
        serialNo:row.serialNo,
        passGateIp:row.passGateIp
      }
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteEquipPassGate({
          passGateId: row.passGateId,
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = 'DTU设备绑定'
      this.addFormVisible = true
      this.addForm = {
         passGateId:'',
         passGateName:'',
         projectId:'',
         passGateIp:'',
      }
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.passGateId == '') {
           that.addForm.projectId = that.groupId
            //添加
            myHttp.addEquipPassGate(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            myHttp.editEquipPassGate(that.addForm).then(function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.addFormVisible = false
                that.getList()
              } else {
                that.$message.error(resp.data.msg)
              }
            },function() {})
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
    },
    doFilter(){
      this.currentPage = 1
      this.getList()
    },
    //一键下发卡号
    downCard(){
      var that = this
      myHttp.clickDistribute({
        projectId:this.groupId
      }).then(function(resp){
        if(resp.data.code=='200'){
          that.$message.success('下发成功')
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },
  }
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  /* justify-content: flex-end; */
  align-items: center;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
</style>